type Valuable<T> = { [P in keyof T as T[P] extends null | undefined ? never : P]: NonNullable<T[P]> };

export function removeNullableProperties<T extends object, V = Valuable<T>>(obj: T): V {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined) {
      acc[key as keyof T] = value;
    }

    return acc;
  }, {} as Partial<T>) as V;
}
